"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCard = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var borderWidths_1 = __importDefault(require("../../tokens/borderWidths"));
var colors_1 = __importDefault(require("../../tokens/colors"));
var radii_1 = __importDefault(require("../../tokens/radii"));
var spacing_1 = __importDefault(require("../../tokens/spacing"));
exports.TableCard = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: ", " solid ", ";\n  border-radius: ", ";\n  padding: ", ";\n"], ["\n  border: ", " solid ", ";\n  border-radius: ", ";\n  padding: ", ";\n"])), borderWidths_1.default.regular, colors_1.default.n70, radii_1.default.rounded, spacing_1.default.space24);
var templateObject_1;
//# sourceMappingURL=index.js.map